import { render, staticRenderFns } from "./VuesticIconVuestic.vue?vue&type=template&id=13b087ef"
import script from "./VuesticIconVuestic.vue?vue&type=script&lang=js"
export * from "./VuesticIconVuestic.vue?vue&type=script&lang=js"
import style0 from "./VuesticIconVuestic.vue?vue&type=style&index=0&id=13b087ef&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b087ef')) {
      api.createRecord('13b087ef', component.options)
    } else {
      api.reload('13b087ef', component.options)
    }
    module.hot.accept("./VuesticIconVuestic.vue?vue&type=template&id=13b087ef", function () {
      api.rerender('13b087ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-icon/VuesticIconVuestic.vue"
export default component.exports